import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/dist/client/router';
import Link from 'next/link';
import Slider from 'react-slick';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import { getPublicPath } from 'utils/paths';
import { Heading2 } from '../../shared/Typography';
import {
  StyledTeam,
  StyledTeamIntro,
  StyledTeamSlide,
  StyledTeamSlideCaption,
  StyledTeamSlideImg,
  StyledTeamSlider
} from './JoinUsTeam.styled';

const JoinUsTeamComponent: React.FC = () => {
  const { t } = useI18n('join-us');
  const { locale } = useRouter();

  const settings = {
    dots: true,
    arrows: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  const teamSlides = [
    {
      caption: 'team1',
      img: 'team1.jpg'
    },
    {
      caption: 'team2',
      img: 'team2.jpg'
    },
    {
      caption: 'team3',
      img: 'team3.jpg'
    },
    {
      caption: 'team4',
      img: 'team4.jpg'
    },
    {
      caption: 'team5',
      img: 'team5.jpg'
    },
    {
      caption: 'team6',
      img: 'team6.jpg'
    }
  ];

  return (
    <StyledTeam>
      <div>
        <StyledTeamIntro>
          <Heading2 editorial>{t('who.title')}</Heading2>
          <div
            dangerouslySetInnerHTML={{
              __html: t('who.desc')
            }}
          ></div>
          <p>
            {t('who.knowOurFredders')}{' '}
            <Link href={getAppUrl(APP_URLS.team, locale)} passHref>
              <a>{t('who.here')}</a>
            </Link>
            .
          </p>
        </StyledTeamIntro>
        <StyledTeamSlider>
          <Slider {...settings}>
            {teamSlides.map((s, i) => (
              <StyledTeamSlide key={i}>
                <StyledTeamSlideImg
                  src={getPublicPath('/images/joinUs/' + s.img)}
                  alt=""
                />
                <StyledTeamSlideCaption>
                  <FontAwesomeIcon icon={faInfoCircle} />
                  {t(`who.slider.${s.caption}`)}
                </StyledTeamSlideCaption>
              </StyledTeamSlide>
            ))}
          </Slider>
        </StyledTeamSlider>
      </div>
    </StyledTeam>
  );
};

export default JoinUsTeamComponent;
